module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "notification",
    class: _vm.notification.type ? _vm.notification.type : 'secondary',
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [(_vm.notification.title) ? _c('h5', [_vm._v(_vm._s(_vm.notification.title))]) : _vm._e(), (!_vm.isArray) ? _c('p', [_vm._v(_vm._s(_vm.notification.text))]) : _vm._e(), (_vm.isArray) ? _c('ul', _vm._l((_vm.notification.text), function(content) {
    return _c('li', [_vm._v(_vm._s(content))])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f221723","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/notifications/Notification.vue
// module id = uVal
// module chunks = 0 1